module.exports = __webpack_public_path__ + "static/img/img-carousel-prop-4-v2.d70e9f9.png";